import { InjectionKey } from 'vue';

/** The building page's dialogs for getting units, which its header owns, opened from the tab below it. */
export interface UnitActions {
  /** Add unit: a new draft on the building's address */
  addUnit: () => void;
  /** Attach existing home: standing apartments filed in as units */
  attachHomes: () => void;
}

export const unitActionsKey: InjectionKey<UnitActions> = Symbol('unitActions');
